module.exports = __webpack_public_path__ + "img/img.7c0c0e9c.png";